
export class EditResourceModel
{
      ResourceId:string
      ResourceSet :string
      ValueEN :string
      ValueAR :string
      CommentEn :string
      CommentAr :string

}
     